import Layout from 'src/components/layouts';
// import client from 'src/utils/client';
import parse from 'html-react-parser';
import _ from 'lodash';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { useRouter } from 'next/router';
import PageError from 'pages/404';
import CardV from 'src/components/cards-video/card-v';
import SecFullH from 'src/components/sections/section-video/sec-full-h';
import { APP_URL, IS_NO_ROBOT_INDEX, SHOW_COMMEMORATE } from 'src/constants';
import { IMAGE_DEFAULT, WEB_DESC, WEB_KEYWORD, WEB_NAME, WEB_TITLE, WEB_URL } from 'src/constants/layout';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { useDesktop } from 'src/utils/device';
import { escapeChar } from 'src/utils/helper';
import { GET } from 'src/utils/services';
import useUser from 'src/utils/useUser';

const PageVideoCategory = ({ dataLive = null, dataAdsHeader }) => {
  const _data = useUser();
  const sessionSevId = _data?.user ? decryptionClient(_data?.user) : null;
  if (_.isEmpty(dataLive)) return <PageError dataAdsHeader={dataAdsHeader} sessionSevId={sessionSevId} />;
  const dataConcat1 = dataLive?.block1.data || [];
  const dataConcat2 = dataLive?.block2.data || [];
  const dataConcat3 = dataLive?.block3.data || [];
  const dataConcat4 = [...new Set(dataConcat1.concat(dataConcat2).concat(dataConcat3))];
  const router = useRouter();
  const baseUrlCategory = `${APP_URL}${router.asPath}`;
  const articleDescriptionSeo = escapeChar(dataLive.metaTag?.description) || WEB_DESC;

  return (
    <>
      {/* -------------------------------- NEXT_SEO -------------------------------- */}
      <NextSeo
        noindex={IS_NO_ROBOT_INDEX}
        nofollow={IS_NO_ROBOT_INDEX}
        title={dataLive.metaTag?.title ? `${dataLive.metaTag?.title}` : WEB_TITLE}
        description={dataLive.metaTag?.description || WEB_DESC}
        robotsProps={{
          maxImagePreview: 'large',
          maxSnippet: -1,
          maxVideoPreview: -1
        }}
        openGraph={{
          type: 'article',
          locale: 'th_TH',
          site_name: WEB_NAME,
          title: dataLive.metaTag?.title ? `${dataLive.metaTag?.title}` : WEB_TITLE,
          description: dataLive.metaTag?.description || WEB_DESC,
          url: baseUrlCategory,
          images: [
            {
              url: IMAGE_DEFAULT,
              width: '1920',
              height: '1080',
              alt: WEB_NAME
            }
          ]
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: dataLive.metaTag?.keyword || WEB_KEYWORD
          }
        ]}
      />
      {/* --------------------------------- HEADER --------------------------------- */}
      <Head>
        <link rel='canonical' href={baseUrlCategory} />
        <meta property='twitter:title' content={dataLive.metaTag?.title ? `${dataLive.metaTag?.title}` : WEB_TITLE} />
        <meta property='twitter:description' content={dataLive.metaTag?.description || WEB_DESC} />
        <meta property='twitter:image' content={IMAGE_DEFAULT} />
        {/* ----------------------------- ScriptBrowser ------------------------------------ */}
        {!useDesktop() && !_.isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_mobile}`) : ''}
        {useDesktop() && !_.isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_desktop}`) : ''}
        {/* ----------------------------- ADS : PPN ------------------------------- */}
        <script async type='text/javascript' src='https://securepubads.g.doubleclick.net/tag/js/gpt.js' />
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: 'var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];'
          }}
        />

        {/* ------------------------------- Truehit -------------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `
                __th_page="วิดีโอ";
              `
          }}
        />

        {/* ---------------------------- SNIPPET : WebSite --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
                {
                  "@context": "https://schema.org",
                  "@type": "WebSite",
                  "name": "${WEB_NAME}",
                  "url": "${WEB_URL.WEB}",
                  "description": "${articleDescriptionSeo}",
                  "sameAs": [
                    "${WEB_URL.FACEBOOK}",
                    "${WEB_URL.YOUTUBE}",
                    "${WEB_URL.INSTAGRAM}"
                  ],
                  "potentialAction": {
                    "@type": "SearchAction",
                    "target": "${WEB_URL.WEB}search?q={search_term_string}",
                    "query-input": "required name=search_term_string"
                  }
                }
              `
          }}
        />

        {/* ---------------------------- SNIPPET : WebPage --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
              {
                    "@context": "http://schema.org",
                    "@type": "WebPage",
                    "name": "วิดีโอ",
                    "description": "${articleDescriptionSeo}",
                    "publisher": {
                      "@type": "ProfilePage",
                      "name": "${WEB_NAME}"
                    }
                  }
                  `
          }}
        />

        {/* ------------------------ SNIPPET : BreadcrumbList ------------------------ */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
              {
                "@context": "http://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": "[
                  {
                      "@type": "ListItem",
                      "position": 1,
                      "name": "หน้าแรก",
                      "item": "${APP_URL}"
                    },
                    {
                      "@type": "ListItem",
                      "position": 2,
                      "name": "วิดีโอ",
                      "item": "${APP_URL}/live/video"
                    }
                  ]"
                  
                }
                `
          }}
        />
        {/* <img
          width='99999'
          height='99999'
          alt='background-default'
          title='background-default'
          className='background-default'
          style={{
            pointerEvents: 'none',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '99vw',
            height: '99vh',
            maxWidth: '99vw',
            maxHeight: '99vh'
          }}
          src='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI5OTk5OXB4IiBoZWlnaHQ9Ijk5OTk5cHgiIHZpZXdCb3g9IjAgMCA5OTk5OSA5OTk5OSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48ZyBzdHJva2U9Im5vbmUiIGZpbGw9Im5vbmUiIGZpbGwtb3BhY2l0eT0iMCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9Ijk5OTk5IiBoZWlnaHQ9Ijk5OTk5Ij48L3JlY3Q+IDwvZz4gPC9zdmc+'
        ></img> */}
      </Head>
      <Layout sessionSevId={sessionSevId}>
        {/* -------------------------------------------------------------------------- */}
        <div className='container mb-5' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}>
          {/* ----------------------------- Breadcrumb -------------------------- */}
          <div className='row'>
            <div className='col-12'>
              <div className='category-wrapper'>
                <ul className='breadcrumb'>
                  <li>
                    <a href='/'>หน้าแรก</a>
                  </li>
                  <li>
                    <a href={'/live/video'}>วีดีโอ</a>
                  </li>
                </ul>
                <h1 className='heading-title'>{'วิดีโอ'}</h1>
              </div>
            </div>
          </div>

          {!_.isEmpty(dataConcat4) && (
            <>
              <div className='row'>
                <SecFullH
                  data={dataConcat4.slice(0, 5)}
                  //! DATALAYER
                  eventDataLayer={{
                    type: DATALAYER_TYPE.TRACK_POSITION,
                    router: router?.pathname,
                    section: 'Most Watched',
                    position: 'ใต้:header',
                    data: {
                      heading: 'Most Watched'
                    }
                  }}
                />
              </div>
              <div className='row mt-4 card-category'>
                {dataConcat4.slice(5).map((item, index) => (
                  <div className='col-6 col-md-4 col-lg-3' key={index}>
                    <CardV
                      data={item}
                      path={`/live/${item?.section.en}/${item.id}`}
                      //! DATALAYER
                      eventDataLayer={{
                        type: DATALAYER_TYPE.TRACK_POSITION,
                        router: router?.pathname,
                        section: 'วิดีโอทั้งหมด',
                        position: 'ใต้:Most Watched',
                        data: {
                          title: item.title,
                          heading: 'วิดีโอทั้งหมด',
                          index: index + 1
                        }
                      }}
                    />
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </Layout>
    </>
  );
};
export async function getServerSideProps({ req, res, query }) {
  const initProps = {
    statusCode: 200,
    errMessage: null,
    articles: [],
    category: [],
    subCategory: [],
    meta: [],
    dataLive: [],
    dataAdsHeader: null
  };

  // initProps.queryCategory = query;
  // let uri = 'categories/news';
  // if (query?.sub) {
  //   uri = `categories/${query?.cid}/${query?.sub}`;
  // }
  const scriptBrowser = await GET('/api/headerAds');
  if (!_.isEmpty(scriptBrowser)) {
    initProps.dataAdsHeader = scriptBrowser || '';
  }
  try {
    const live = await GET('/api/v1.0/video/section-one');
    // console.log('live', live);
    // const live = await client.fetch.get('/api/search/video/tag?name=%E0%B9%80%E0%B8%A8%E0%B8%A3%E0%B8%A9%E0%B8%90%E0%B8%81%E0%B8%B4%E0%B8%88'); // เศรษฐกิจ
    if (!_.isEmpty(live)) {
      initProps.dataLive = live;
    }
    // if ('msg' in data) {
    //   initProps.articles = null;
    //   initProps.meta = data.meta;
    // } else {
    //   initProps.articles = data.data;
    //   // initProps.category = data.category;
    //   // initProps.subCategory = data.subCategory;
    //   // initProps.lastNews = data.last_news;
    // }
  } catch (err) {
    console.log('==========> CATEGORY ERROR', err.message);
    initProps.errMessage = err.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return {
    props: initProps
  };
}
export default PageVideoCategory;
